import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiKoType, ApiKoTypesFilter } from "./types";

interface KoTypesListResponse {
    kotypes: ApiKoType[];
}

/**
 * Транспортный слой OMP — типы конструкторских объектов.
 */
export const koTypesApi = {
    /**
     * Загружает типы конструкторских объектов по фильтру.
     * Запрос уходит в endpoint `konstrobj/konstrobjs.loadKOTypes`.
     */
    load: async (params: { flt?: ApiKoTypesFilter }, config?: RequestConfig): Promise<ApiKoType[]> => {
        const data = await ompApiClient.postOmega<KoTypesListResponse>("konstrobj/konstrobjs.loadKOTypes", params, config);
        return data.kotypes;
    },
} as const;
